import { DateTime as DT } from 'luxon';
import type { DocumentSourceSnapshotType } from '@econtractor/types';

export const DOCUMENT_TEMPLATE_KEYS = ['docName', 'docNumber', 'docDate', 'sourceDocName', 'sourceDocNumber', 'sourceDocDate'] as const;

export type DocumentTemplateKey = (typeof DOCUMENT_TEMPLATE_KEYS)[number];

export interface BuildDocumentTemplateValueKeysParams {
    proposalName?: string | null;
    sourceDocument?: DocumentSourceSnapshotType;
    proposalNumber?: string | null;
    proposalDt?: number | null;
}

const escapeHtml = (value: string): string =>
    value
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;');

const formatDocDate = (raw: unknown): string => {
    const millis = Number(raw || 0);
    if (!Number.isFinite(millis) || millis <= 0) return '';
    const date = DT.fromMillis(millis);
    return date.isValid ? date.toFormat('dd.MM.yyyy') : '';
};

/** Builds replaceable keys from current document requisites and its source snapshot. */
export const buildDocumentTemplateValueKeysMap = ({
    proposalName,
    proposalNumber,
    proposalDt,
    sourceDocument,
}: BuildDocumentTemplateValueKeysParams): Record<string, string> => ({
    docName: escapeHtml(String(proposalName || '').trim()),
    docNumber: escapeHtml(String(proposalNumber || '').trim()),
    docDate: formatDocDate(proposalDt),
    sourceDocName: escapeHtml(String(sourceDocument?.name || '').trim()),
    sourceDocNumber: escapeHtml(String(sourceDocument?.number || '').trim()),
    sourceDocDate: formatDocDate(sourceDocument?.date),
});
